(ns bp-clients.tv-app.utils.qrcode
  (:require [qrcode-generator]))

(defn generate-qr-code
  "Generates the qr-code svg string

  ref: https://www.npmjs.com/package/qrcode-generator"
  [url size margin]
  (as-> url url-code
    (.createSvgTag
     (doto
      (qrcode-generator. 4 "L")
       (.addData url-code)
       (.make))
     size margin)))
